<template>
  <div>
    <div v-if="visibleProducts.length === 0" class="text-center py-12">
      <p class="text-gray-500">Aucun produit disponible pour votre grille tarifaire dans cette catégorie.</p>
    </div>
    <div v-else class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 justify-center lg:justify-start mb-3">
    <template v-for="(product, index) in visibleProducts">
      <category-merchandising-block
        v-if="merchandisingBlockPositions[index]"
        :key="`${product.id}-merchandising`"
        :class="[index % 5 === 4 ? 'lg:hidden' : 'lg:block', index % 4 === 3 ? 'md:hidden' : 'md:block', index % 2 === 1 ? 'hidden' : 'block']"
        :merchandising-block="merchandisingBlockPositions[index]"
      ></category-merchandising-block>
      <div
        :key="product.id"
        class="mb-6"
      >
        <product-card
          :product="product"
          :list-name="category.url"
          :list-id="category.slug"
          :position="index + 1"
          @click="$gtmEvents.onProductCardClick(product, category.label, index + 1)"
        />
      </div>
      <category-merchandising-block
        v-if="merchandisingBlockPositions[index]"
        :key="`${product.id}-merchandising-2`"
        :class="[index % 5 === 4 ? 'lg:block' : 'lg:hidden', index % 4 === 3 ? 'md:block' : 'md:hidden', index % 2 === 1 ? 'block' : 'hidden']"
        :merchandising-block="merchandisingBlockPositions[index]"
      ></category-merchandising-block>
    </template>
    </div>
  </div>
</template>

<script>
import ProductCard from '../general/ProductCard'
import CategoryMerchandisingBlock from './CategoryMerchandisingBlock.vue'

export default {
  components: {
    ProductCard,
    CategoryMerchandisingBlock
  },
  props: {
    category: {
      required: true,
      type: Object
    },
    result: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      showFilters: false,
      columnsSize: 5
    }
  },
  mounted () {
    this.$gtmEvents.onCategoryView(this.result.hits, this.category.label, this.category.slug)
  },
  computed: {
    visibleProducts () {
      if (!this.result || !this.result.hits) {
        return []
      }
      return this.result.hits.filter(product => {
        if (!product.pricing) {
          return false
        }
        return (product.pricing.unit_price > 0) || (product.pricing.unit_taxed_price > 0)
      })
    },
    merchandisingBlocks () {
      return this.category.properties?.bloc_merchandising?.map((block) => {
        return block.attributes
      }) || []
    },
    merchandisingBlockPositions () {
      const positions = this.category.properties?.bloc_position?.split(',').map(item => parseInt(item.trim())) || []
      const result = Object.assign({}, ...positions.map((position, positionIndex) => {
        return {
          [position]: this.merchandisingBlocks[positionIndex]
        }
      }))
      return result
    }
  }
}
</script>
